import { z } from 'zod';
import { ReservationStatus } from '@mews-commander/data-access';
import { ProductCheckListTableColumn } from '../../../containers/ProductCheckListTable/types';

export enum FilterValueKey {
    date = 'date',
    displayReservationsWithoutProducts = 'displayReservationsWithoutProducts',
    reservationStatus = 'reservationStatus',
    productIds = 'productIds',
    displayedColumns = 'displayedColumns',
    claimedProducts = 'claimedProducts',
}

export enum ProductCheckListFilterSection {
    Products = 'Products',
    Reservations = 'Reservations',
    AdvancedSettings = 'AdvancedSettings',
}

export enum ClaimedProductsBy {
    Total = 'Total',
    AgeCategories = 'AgeCategories',
}

const stringToArrayTransform = <T>(arg: T | T[]): T[] => (Array.isArray(arg) ? arg : [arg]);

export const productCheckListFiltersSchema = z.object({
    [FilterValueKey.date]: z.string().datetime(),
    [FilterValueKey.productIds]: z.record(
        z
            .union([z.array(z.string()), z.string()])
            .transform(stringToArrayTransform)
            .optional()
    ),
    [FilterValueKey.reservationStatus]: z
        .union([z.array(z.nativeEnum(ReservationStatus)), z.nativeEnum(ReservationStatus)])
        .transform(stringToArrayTransform),
    [FilterValueKey.displayReservationsWithoutProducts]: z.coerce.boolean(),

    [FilterValueKey.displayedColumns]: z
        .union([
            z.array(z.nativeEnum(ProductCheckListTableColumn)).nonempty(),
            z.nativeEnum(ProductCheckListTableColumn),
        ])
        .transform(stringToArrayTransform),
    [FilterValueKey.claimedProducts]: z.nativeEnum(ClaimedProductsBy),
});

/**
 * Filters schema edited for usage in url params
 * - no date field
 * - boolean values are stringified -> transform them to boolean
 */
export const productCheckListFiltersQuerySchema = productCheckListFiltersSchema
    .omit({
        [FilterValueKey.date]: true,
        // [FilterValueKey.displayReservationsWithoutProducts]: true,
    })
    .extend({
        [FilterValueKey.displayReservationsWithoutProducts]: z
            .enum(['true', 'false'])
            .or(z.boolean())
            .transform<boolean>((arg) => (typeof arg === 'string' ? arg === 'true' : arg)),
    })
    .partial();
export const productCheckListDefaultFiltersSchema = productCheckListFiltersSchema.omit({ [FilterValueKey.date]: true });
export type ProductCheckListFilterValues = z.infer<typeof productCheckListFiltersSchema>;
